import { z } from 'zod';
import {
    CloverErrorDetailType,
    type CloverErrorDetails,
    type CloverGatewayErrorObject,
    type CloverGatewayJsonErrorBody,
} from '../../../types/ipg/clover/clover-error.types';

export const CloverGatewayErrorObjectSchema: z.ZodType<CloverGatewayErrorObject> = z
    .object({
        message: z.string().min(1).optional(),
        code: z.string().min(1).optional(),
        type: z.string().min(1).optional(),
        decline_code: z.string().min(1).optional(),
    })
    .catchall(z.unknown());

export const CloverGatewayJsonErrorBodySchema: z.ZodType<CloverGatewayJsonErrorBody> = z
    .object({
        message: z.string().min(1).optional(),
        error: z.union([z.string().min(1), CloverGatewayErrorObjectSchema]).optional(),
        errorMessage: z.string().min(1).optional(),
        error_description: z.string().min(1).optional(),
        code: z.string().min(1).optional(),
        errorCode: z.string().min(1).optional(),
        error_code: z.string().min(1).optional(),
        type: z.string().min(1).optional(),
        requestId: z.string().min(1).optional(),
        request_id: z.string().min(1).optional(),
        requestType: z.string().min(1).optional(),
    })
    .catchall(z.unknown());

export const CloverErrorDetailsSchema: z.ZodType<CloverErrorDetails> = z.discriminatedUnion(
    'error_detail_type',
    [
        z.object({
            error_detail_type: z.literal(CloverErrorDetailType.JSON_ERROR),
            operation: z.string().min(1),
            message: z.string().min(1),
            http_status: z.number().int().positive().optional(),
            error_code: z.string().min(1).optional(),
            error_type: z.string().min(1).optional(),
            request_id: z.string().min(1).optional(),
            raw_body: CloverGatewayJsonErrorBodySchema,
        }),
        z.object({
            error_detail_type: z.literal(CloverErrorDetailType.TEXT_ERROR),
            operation: z.string().min(1),
            message: z.string().min(1),
            http_status: z.number().int().positive().optional(),
            raw_text: z.string(),
        }),
        z.object({
            error_detail_type: z.literal(CloverErrorDetailType.HTTP_STATUS_ERROR),
            operation: z.string().min(1),
            message: z.string().min(1),
            http_status: z.number().int().positive(),
        }),
        z.object({
            error_detail_type: z.literal(CloverErrorDetailType.NETWORK_ERROR),
            operation: z.string().min(1),
            message: z.string().min(1),
            error_name: z.string().min(1).optional(),
        }),
    ]
);
